module.exports = __webpack_public_path__ + "img/tail.f4a724ac.png";